import { ProvisionStatusKeyFactory } from '../../query-key-factories';
export const provisionStatusQueryFactory = (lucidSdk, workspaceId) => ({
    queryKey: ProvisionStatusKeyFactory.provisionStatus(workspaceId),
    queryFn: () => lucidSdk.workspaceClient(workspaceId).getFilespaceProvisionStatus(),
});
